/* Every Knowledge Hub document lives in exactly one folder, and every number
   on the page is counted from this one rule.

   The General card used to count every General document, while its category
   folders only counted documents that had a category. A document still being
   read, or one whose reading failed, has no category yet, so the totals did
   not add up and that document could only be found by searching. The partner
   folders came from a second server list that split one partner into two
   folders when their name had been saved two ways. */

export const CATEGORY_KEYS = ['product', 'market', 'partner', 'general'];
export const UNSORTED = 'unsorted';
export const NO_PARTNER = 'no-partner';

export function folderOf(doc) {
  if (doc.storage_area === 'crm') {
    return { area: 'crm', key: doc.partner_id ?? NO_PARTNER };
  }
  // Anything not filed under CRM is shown under General, never dropped.
  return {
    area: 'general',
    key: CATEGORY_KEYS.includes(doc.classification) ? doc.classification : UNSORTED,
  };
}

export function isStillReading(doc) {
  return doc.processing_status === 'pending' || doc.processing_status === 'processing';
}

export function buildFolders(documents) {
  const partnerFolders = new Map();
  const generalFolders = new Map([...CATEGORY_KEYS, UNSORTED].map((key) => [key, []]));
  const crmDocs = [];
  const generalDocs = [];

  documents.forEach((doc) => {
    const { area, key } = folderOf(doc);
    if (area === 'crm') {
      crmDocs.push(doc);
      if (!partnerFolders.has(key)) {
        partnerFolders.set(key, {
          partnerId: key,
          // Documents arrive newest first, so the folder takes the latest name.
          partnerName: key === NO_PARTNER ? 'No partner linked' : doc.partner_name || 'Unnamed partner',
          docs: [],
        });
      }
      partnerFolders.get(key).docs.push(doc);
    } else {
      generalDocs.push(doc);
      generalFolders.get(key).push(doc);
    }
  });

  const partners = [...partnerFolders.values()].sort((a, b) =>
    a.partnerName.localeCompare(b.partnerName, undefined, { sensitivity: 'base' })
  );
  const unsorted = generalFolders.get(UNSORTED);

  return {
    crmDocs,
    generalDocs,
    partners,
    partnerCount: partners.filter((p) => p.partnerId !== NO_PARTNER).length,
    generalFolders,
    unsortedFailed: unsorted.filter((d) => d.processing_status === 'failed').length,
    unsortedReading: unsorted.filter(isStillReading).length,
  };
}
